import React from "react";

const AppTablePane = React.forwardRef(function AppTablePane({ className = "", children, ...props }, ref) {
  const classes = ["ds-table-pane", className].filter(Boolean).join(" ");

  return (
    <div ref={ref} className={classes} {...props}>
      {children}
    </div>
  );
});

export default AppTablePane;
